module.exports = __webpack_public_path__ + "static/media/18ECA11.801a4475.jpg";